import axios from "../plugins/axios";

export default {
  getMimeTypeByExtention(extension) {
    const url = `/web_api/v1/document/mime_type_by_extension/${extension}`;
    return axios.get(url)
      .then((response) => response.data);
  },
  create(
    customer,
    attachableCategory,
    hasAttachableType,
    hasAttachableId,
    name,
    mimeType,
    extension,
    file,
    onProgressCallback,
  ) {
    const url = "/web_api/v1/document";
    const formData = new FormData();
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: onProgressCallback,
    };

    formData.append("name", name);
    formData.append("mime_type", mimeType);
    formData.append("extension", extension);
    formData.append("content", file);

    if (typeof customer !== "undefined" && customer !== null) {
      formData.append("customer_id", customer.id);
    }

    if (
      typeof hasAttachableType !== "undefined" && hasAttachableType !== null
            && typeof hasAttachableId !== "undefined" && hasAttachableId !== null
    ) {
      formData.append("has_attachable_type", hasAttachableType);
      formData.append("has_attachable_id", hasAttachableId);
    }

    if (typeof attachableCategory !== "undefined" && attachableCategory !== null) {
      formData.append("attachable_category_id", attachableCategory.id);
    }

    return axios.post(url, formData, config)
      .then((response) => response.data);
  },
  findAll(documentIds, includes = []) {
    return axios.post("/web_api/v1/document/find_all", { document_ids: documentIds }, {
      params: {
        include: includes,
      },
    })
      .then((response) => response.data);
  },
  findAllQueued(documentIds, includes = []) {
    return axios.post("/web_api/v1/document/find_all_queued", {
      document_ids: documentIds,
    }, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
  findAllProcessed(documentIds, includes = []) {
    return axios.post("/web_api/v1/document/find_all_processed", {
      document_ids: documentIds,
    }, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
  getByDossier(dossierId, includes = []) {
    const url = `/web_api/v1/document/by_dossier/${dossierId}`;
    return axios.get(url, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
  getByMortgage(mortgageId, includes = []) {
    const url = `/web_api/v1/document/by_mortgage/${mortgageId}`;
    return axios.get(url, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
  find(documentId) {
    const url = `/web_api/v1/document/${documentId}`;
    return axios.get(url)
      .then((response) => response.data);
  },
  processDocuments(documentIds, dossierId, mortgageId, userId, includes = []) {
    return axios.post("/web_api/v1/document/process", {
      document_ids: documentIds,
      dossier_id: dossierId,
      mortgage_id: mortgageId,
      user_id: userId,
    }, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
  update(document) {
    const url = `/web_api/v1/document/${document.id}`;
    return axios.put(url, document)
      .then((response) => response.data);
  },
};
